import React from "react";
import { DynamicFormIcon, tableEditIcon } from "../../../../assets/images";
import moment from "moment";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "../../style/index.scss";
import { formateDateTime } from "../../../../utils/commonFunctions";
import UpdatedByAndUpdatedAt from "../../../commons/CommonUpdatedByAndUpdatedAt";

type AppProps = {
  data: any;
  header: TableHeadersType[];
  history: any;
  isEditJobsTypePresent?: boolean;
  handleChangeStatus: (e: any, data: string) => void;
  searchTerm?: string;
  isViewChecklist: boolean;
};

const JobsTableBody = ({
  data,
  header,
  history,
  isViewChecklist,
  isEditJobsTypePresent,
  searchTerm,
  handleChangeStatus,
}: AppProps) => {
  const handleEdit = (id: string) => {
    history?.push({
      pathname: `/jobs/jobs-type/edit/${id}`,
      state: { id, searchTerm },
    });
  };

  return (
    data?.length > 0 &&
    data?.map((dataItem: any) => {
      return (
        <tr>
          {header?.map((headerData: TableHeadersType) => {
            if (headerData?.value === "short_code") {
              return <td>{dataItem?.short_code}</td>;
            } else if (headerData?.value === "job_type") {
              return (
                <td style={{ width: "160px", wordBreak: "break-all" }}>
                  {dataItem?.job_type}
                </td>
              );
            } else if (headerData?.value === "description") {
              return (
                <td>
                  {dataItem?.job_details?.length > 8 ? (
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-filter-invoice">
                          {dataItem?.job_details}
                        </Tooltip>
                      }
                    >
                      <span>
                        {`${dataItem?.job_details}`?.slice(0, 8) +
                          (dataItem?.job_details?.length > 8 ? "..." : "")}
                      </span>
                    </OverlayTrigger>
                  ) : (
                    dataItem?.job_details
                  )}
                </td>
              );
            } else if (headerData?.value === "period_length") {
              return (
                <td>
                  {dataItem?.recurring_job_settings?.repeat_period_length &&
                  dataItem?.recurring_job_settings?.repeat_period
                    ? `${
                        dataItem?.recurring_job_settings?.repeat_period_length
                      } ${
                        dataItem?.recurring_job_settings?.repeat_period ==
                        "Monthly"
                          ? "months"
                          : dataItem?.recurring_job_settings?.repeat_period ==
                            "Yearly"
                          ? "years"
                          : dataItem?.recurring_job_settings?.repeat_period ==
                            "Weekly"
                          ? "weeks"
                          : "days"
                      }`
                    : "NA"}
                </td>
              );
            } else if (headerData?.value === "next_period_end") {
              return (
                <td>
                  {dataItem?.recurring_job_settings?.next_period_end_date
                    ? moment(
                        dataItem?.recurring_job_settings?.next_period_end_date,
                        "YYYY-MM-DD"
                      ).format("DD-MM-YYYY")
                    : "NA"}
                </td>
              );
            } else if (headerData?.value === "create_job_at") {
              return (
                <td>
                  {dataItem?.recurring_job_settings?.create_job_period
                    ? dataItem?.recurring_job_settings?.create_job_period
                    : "NA"}
                </td>
              );
            } else if (headerData?.value === "target_end_date") {
              return (
                <td>
                  {dataItem?.recurring_job_settings?.target_end_date
                    ?.period_length &&
                  dataItem?.recurring_job_settings?.target_end_date?.period
                    ? `${dataItem?.recurring_job_settings?.target_end_date?.period_length}  ${dataItem?.recurring_job_settings?.target_end_date?.period}`
                    : "NA"}
                </td>
              );
            } else if (headerData?.value === "updated_by") {
              return (
                <td style={{ width: "180px" }}>
                  <UpdatedByAndUpdatedAt
                    firstName={dataItem?.updated_by?.first_name}
                    lastName={dataItem?.updated_by?.last_name}
                    profilePic={dataItem?.updated_by?.profile_pic?.file_url}
                    updatedAt={formateDateTime(dataItem?.updated_at)}
                  />
                </td>
              );
            } else if (headerData?.value === "status") {
              return (
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "3px",
                    }}
                  >
                    <label className="switchs m-0">
                      <input
                        type="checkbox"
                        checked={dataItem?.status === 0 ? false : true}
                        onChange={() =>
                          handleChangeStatus(dataItem.status, dataItem?._id)
                        }
                        //   disabled={dataItem?.status === 0}
                      />
                      <span className="sliders rounds"></span>
                    </label>
                    <span>{/* Disabled */}</span>
                  </div>
                </td>
              );
            } else if (headerData?.value === "action") {
              return (
                <td style={{ textAlign: "center" }}>
                  {isEditJobsTypePresent && (
                    <span
                      className="d-inline-block pointer"
                      onClick={() => handleEdit(dataItem._id)}
                    >
                      <img src={tableEditIcon} alt="edit" />
                    </span>
                  )}

                  {isViewChecklist ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-open-item">
                          View Checklist
                        </Tooltip>
                      }
                    >
                      <span
                        className="pointer ml-2"
                        onClick={() =>
                          history?.push({
                            pathname: `/jobs/jobs-type/checklist`,
                            state: { job_id: dataItem?._id },
                          })
                        }
                      >
                        <img src={DynamicFormIcon} alt="checkList" />
                      </span>
                    </OverlayTrigger>
                  ) : null}
                </td>
              );
            }
          })}
        </tr>
      );
    })
  );
};

export default JobsTableBody;
